import { CardiacConstants } from '../store/cardiac.constants'

export const cardiacSchemas = [
  {
    inputKey: CardiacConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: CardiacConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: CardiacConstants.SET_HEART_RATE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_HEART_RATE: {
        type: 'number',
        minimum: 0,
        maximum: 48,
      },
    },
    additionalProperties: false,
    required: ['SET_HEART_RATE'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be 0 to 48',
      },
    },
  },
  {
    inputKey: CardiacConstants.SET_JOULES,
    isNumber: true,
    type: 'object',
    properties: {
      SET_JOULES: {
        type: 'number',
        minimum: 0,
        maximum: 360,
      },
    },
    additionalProperties: false,
    required: ['SET_JOULES'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be 0 to 360',
      },
    },
  },
]

export const cardiacSecondsSchemas = [
  {
    inputKey: CardiacConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
